import {
  AnnotationQuestion,
  Bank,
  BankNote01,
  BracketsEllipses,
  Colors,
  Compass03,
  File05,
  FileSearch02,
  FolderPlus,
  Hook,
  LineChartUp02,
  List,
  PuzzlePiece02,
  SearchRefraction,
  Settings03,
  Ticket01,
  User01,
  User03,
  VideoRecorder,
} from 'ethena-icons';
import { PageName } from 'lib/constants';
// TODO: This needs to go somewhere else.
import { TeamInsightsIcon } from 'components/admin/layout/Navigation/TeamInsightsIcon';
import { Organization } from 'lib/types/company';
import { ElementType } from 'react';

interface IPageConfiguration {
  name: PageName;
  path: string;
  icon: ElementType;
  getLabel: (params: { organization: Organization }) => string;
}

export const ADMIN_PAGES: IPageConfiguration[] = [
  {
    name: PageName.ADMIN_DASHBOARD,
    path: '/dashboard',
    icon: Compass03,
    getLabel: () => 'Dashboard',
  },
  {
    name: PageName.ADMIN_EVENTS,
    path: '/events',
    icon: Ticket01,
    getLabel: () => 'Events',
  },
  {
    name: PageName.ADMIN_TEAM_MEMBERS,
    path: '/team',
    icon: User01,
    getLabel: () => 'Team List',
  },
  {
    name: PageName.ADMIN_TEAM_INSIGHTS,
    path: '/insights',
    icon: TeamInsightsIcon,
    getLabel: () => 'Manager Insights',
  },
  {
    name: PageName.ADMIN_CASE_MANAGEMENT,
    path: '/case-management',
    icon: FileSearch02,
    getLabel: () => 'Case Management',
  },
  {
    name: PageName.ADMIN_CASE_MANAGEMENT_UPSELL,
    path: '/learn-more/case-management',
    icon: FileSearch02,
    getLabel: () => 'Case Management',
  },
  {
    name: PageName.ADMIN_PHISHING,
    path: '/phishing',
    icon: Hook,
    getLabel: () => 'Phishing',
  },
  {
    name: PageName.ADMIN_SETTINGS,
    path: '/settings',
    icon: Settings03,
    getLabel: () => 'Settings',
  },
  {
    name: PageName.ADMIN_CONTENT_LIBRARY,
    path: '/content-library',
    icon: FolderPlus,
    getLabel: () => 'Content Library',
  },
  {
    name: PageName.ADMIN_ANALYTICS,
    path: '/analytics',
    icon: LineChartUp02,
    getLabel: ({ organization }) =>
      organization === Organization.LIFE_LABS ? 'Reports' : 'Analytics',
  },
];

export const INTERNAL_PAGES: IPageConfiguration[] = [
  {
    name: PageName.INTERNAL_COURSES,
    path: '/internal/courses',
    icon: List,
    getLabel: () => 'Courses',
  },
  {
    name: PageName.INTERNAL_SEARCH,
    path: '/internal/content-search',
    icon: SearchRefraction,
    getLabel: () => 'Content Search',
  },
  {
    name: PageName.INTERNAL_QUESTIONS,
    path: '/internal/questions',
    icon: AnnotationQuestion,
    getLabel: () => 'Slide Questions',
  },
  {
    name: PageName.INTERNAL_VIDEO_LIBRARY,
    path: '/internal/videos',
    icon: VideoRecorder,
    getLabel: () => 'Video Library',
  },
  {
    name: PageName.INTERNAL_COMPANIES,
    path: '/internal/companies',
    icon: Bank,
    getLabel: () => 'Companies',
  },
  {
    name: PageName.INTERNAL_TEMPLATES,
    path: '/internal/templates',
    icon: File05,
    getLabel: () => 'Messaging Templates',
  },
  {
    name: PageName.INTERNAL_PREVIEW_LINKS,
    path: '/internal/preview-links',
    icon: BankNote01,
    getLabel: () => 'Preview Links',
  },
  {
    name: PageName.INTERNAL_PARTNERS,
    path: '/internal/partners',
    icon: PuzzlePiece02,
    getLabel: () => 'Partners',
  },
  {
    name: PageName.INTERNAL_THEMES,
    path: '/internal/themes',
    icon: Colors,
    getLabel: () => 'Theme Editor',
  },
  {
    name: PageName.INTERNAL_USER_ROLES,
    path: '/internal/user-roles',
    icon: User03,
    getLabel: () => 'User Roles',
  },
  {
    name: PageName.INTERNAL_STRING_VARIABLES,
    path: '/internal/string-variables',
    icon: BracketsEllipses,
    getLabel: () => 'String Variables',
  },
];
